export default __webpack_public_path__ + "static/media/dhl.ec4206a1.png";